import React from "react";
import { Link, useLocation } from "@/lib/router";
import { motion, AnimatePresence } from "framer-motion";
import { CaretLeft } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const V_MARK = "/vornx/club_v.png";

// Floating "back to the app" control shown to active Founders while they browse the
// boutique/site, so returning to the VORNX Club app is always one tap away.
export const ClubReturnFab = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const f = user?.founder;
  const visible = f && f.status === "active" && !pathname.startsWith("/club") && !pathname.startsWith("/admin");

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 420, damping: 30 }}
          className="fixed bottom-6 right-5 z-[70]"
          style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
          <Link
            to="/club"
            data-testid="club-return-fab"
            className="group flex items-center gap-2.5 rounded-full border border-gold/40 bg-ink/90 py-2.5 pl-3 pr-4 shadow-[0_18px_40px_-12px_rgba(0,0,0,0.8)] backdrop-blur-xl transition-colors hover:border-gold"
          >
            <CaretLeft size={14} weight="bold" className="text-gold transition-transform group-hover:-translate-x-0.5" />
            <img src={V_MARK} alt="" className="h-5 w-5 object-contain" />
            <span className="text-[10px] uppercase tracking-[0.24em] text-gold">Torna al Club</span>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
